import React from 'react';

export default ({ color = '#5E5E5E' }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke={color}
      d="M17.625 11.25H9.75L7.78125 15.75H5.25V17.25H15L17.625 11.25Z"
      fill="#5E5E5E"
    />
    <path
      stroke={color}
      d="M1.5 15.75C1.5 12.0285 4.5285 9 8.25 9C8.50343 9 8.7537 9.01402 9 9.0414L6.80023 14.25H5.25C4.42157 14.25 3.75 14.9215 3.75 15.75V16.84C3.18839 16.7383 2.62753 16.6175 2.06775 16.4775L1.5 16.3358V15.75Z"
      fill="#5E5E5E"
    />
    <path
      stroke={color}
      d="M8.25 7.5C10.114 7.5 11.625 5.98896 11.625 4.125C11.625 2.26104 10.114 0.75 8.25 0.75C6.38604 0.75 4.875 2.26104 4.875 4.125C4.875 5.98896 6.38604 7.5 8.25 7.5Z"
      fill="#5E5E5E"
    />
  </svg>
);
